var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 62,
    viewBox: "0 0 31 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "host-individual-inactive.3d02fbcd 1",
    clipPath: "url(#clip0_3093_118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1147 61.4452C14.7721 61.4452 15.9774 60.3905 15.9774 58.4067V39.1461C15.9774 38.2923 16.3792 37.7901 17.0572 37.7901C17.7353 37.7901 18.1622 38.2923 18.1622 39.1461V58.4067C18.1622 60.3905 19.3675 61.4452 21.0249 61.4452C22.6571 61.4452 23.8625 60.3905 23.8625 58.4067V25.8621C23.8625 25.184 24.1889 24.7823 24.7414 24.7823C25.2687 24.7823 25.6203 25.184 25.6203 25.8621V39.2214C25.6203 41.0044 26.675 42.0088 28.1817 42.0088C29.6884 42.0088 30.718 41.0044 30.718 39.2214V26.1634C30.718 18.203 26.223 16.1439 17.3084 16.1439H13.4412C11.7085 16.1439 10.8296 15.8928 9.44843 14.8883L6.1337 12.5529L5.53102 3.16122C5.40546 1.35318 4.25033 0.398938 2.74363 0.499384C1.21183 0.574719 0.157138 1.67963 0.257584 3.46256L0.860263 12.7789C0.985821 14.813 1.78939 15.9932 3.04497 16.9223L9.07176 21.3169C9.95066 21.9446 10.252 22.7231 10.252 23.7276V58.4067C10.252 60.3905 11.4825 61.4452 13.1147 61.4452ZM17.3084 13.6327C20.6482 13.6327 23.3351 10.8704 23.3351 7.63108C23.3351 4.29124 20.6482 1.57919 17.3084 1.57919C13.9434 1.57919 11.3067 4.29124 11.3067 7.63108C11.3067 10.9207 13.9434 13.6327 17.3084 13.6327Z",
    fill: "#FF614D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3093_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.ab543c402e32c0fdd13a1ad3d9cf82f8.svg";
export { ForwardRef as ReactComponent };